/**
 * Appends the current page's query string (fbclid, gclid, utm_*, agent_id, …)
 * to a navigation destination so ad-click attribution survives the hop between
 * pages (PPI-1747). Params the destination already defines win over forwarded
 * ones; with no current query string the destination is returned untouched.
 * Relative destinations are resolved against the current origin.
 * @param destination - The URL to navigate to (absolute or relative)
 * @returns The destination with the current query string merged in
 */
export default function withForwardedQueryParams(destination: string): string {
  const current = new URLSearchParams(window.location.search);
  if (Array.from(current.keys()).length === 0) return destination;
  const url = new URL(destination, window.location.origin);
  const destinationKeys = new Set(url.searchParams.keys());
  current.forEach((value, key) => {
    if (!destinationKeys.has(key)) url.searchParams.append(key, value);
  });
  return url.toString();
}
